// extracted by mini-css-extract-plugin
export default {"buttonLeft":"inicio-page-styles_component_buttonLeft__WnEA7","buttonRight":"inicio-page-styles_component_buttonRight__2MJeh"};